module.exports = __webpack_public_path__ + "img/eprice-red-round-01hover.4a0dc453.png";